export default "__VITE_ASSET__ItEr6XAn__"